import React from "react";
import { useLocation } from "react-router-dom";

function Progessbar() {

    const location = useLocation();

    return (
        <div className="col-md-4 brIght">

            <section className="section1">
                <header>
                    <div className="bead complete">
                        <span>
                            <i className="fa-solid fa-check"></i>
                        </span>
                    </div>
                    {location.pathname === "/add-order" ? "Add" : "Update"} Personal Information
                </header>
            </section>

            <section className="section2">
                <header>
                    <div className="bead current">
                        <span>2</span>
                    </div>
                    {location.pathname === "/add-order" ? "Add" : "Update"} Styles and Measurements
                </header>
            </section>

            <section>
                <header>
                    <div className="bead">
                        <span>3</span>
                    </div>
                    {location.pathname === "/add-order" ? "Add" : "Update"} Notes
                </header>
            </section>

        </div>
    );
}

export default Progessbar;
